// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --elevation-1: 0px 2px 4px -2px rgba(222, 232, 243, 0.65), 0px 2px 4px -2px rgba(222, 232, 243, 0.65);\n  --elevation-2: 0px 6px 14px -6px rgba(222, 232, 243, 0.65), 0px 10px 32px -4px rgba(222, 232, 243, 0.65);\n  --elevation-3: 0px 14px 64px -4px rgba(222, 232, 243, 0.65), 0px 8px 22px -6px rgba(222, 232, 243, 0.65);\n}\n", ""]);
// Exports
module.exports = exports;
